export const getActiveReason = (specialSchedule) => {
    const activeItem = specialSchedule?.find((item) => item.status === true);
    return activeItem ? activeItem.reason : undefined;
};